import map from "../assets/images/map.jpg";
import { FaTelegram, FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "../i18n";

const Services = () => {
  const { t } = useTranslation();

  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng); // Change language
  // };
  return (
    <>
      <section className="py-5" id="services" data-aos="fade-up">
        <div className="container">
          <div className="row d-flex justify-content-center g-3">
            <div className="col-12 col-md-8 d-flex flex-column align-items-center">
              <img src={map} className="rounded-5" width="100%" alt="..." />
              <p>{t("ServiceP1")}</p>
              <p>
                {t("ServiceP2")} <span>{t("ServiceP3")}</span>
              </p>
              <p>{t("ServiceP4")}</p>
              <p>{t("ServiceP5")}</p>
              <p>{t("ServiceP6")}</p>
              <p>{t("ServiceP7")}</p>
              <p><b>{t("ServiceP8")}</b></p>
              <p>
                {t("ServiceP9")} <span>€ 180</span>
                <br />
                {t("ServiceP10")} <span>€ 200</span>
                <br />
                {t("ServiceP10a")} <span>₽ 3000</span>
                <br />
                {t("ServiceP10b")} <span>₽ 17000</span>
                <br />
                {t("ServiceP10c")} <span>₽ 37000</span>
                <br />
                {t("ServiceP11")} <span>€ 350</span>
                <br />
                {t("ServiceP11a")} <span>₽ 7000</span>
                <br />
                {t("ServiceP12")} <span>€ 230</span>
                <br />
                {t("ServiceP13")} <span>€ 180</span>
                <br />
                {t("ServiceP14")} <span>€ 150</span>
              </p>
              <p><b>{t("ServiceP15")}</b></p>
              <p>
                {t("ServiceP16")} <span>€ 200</span>
                <br />
                {t("ServiceP16a")} <span>₽ 7000</span>
                <br />
                {t("ServiceP19")} <span>€ 220</span>
                <br />
                {t("ServiceP20")} <span>€ 200</span>
                <br />
                {t("ServiceP21")} <span>€ 220</span>
                <br />
                {t("ServiceP22")} <span>€ 200</span>
                <br />
                {t("ServiceP23")} <span>€ 100</span>
              </p>
              <p><b>{t("ServiceP24")}</b></p>
              <p>
                {t("ServiceP25")} <span>€ 70</span>
                <br />
                {t("ServiceP26")} <span>€ 130</span>
                <br />
                {t("ServiceP27")} <span>€ 170</span>
                <br />
                {t("ServiceP28")} <span>€ 170</span>
                <br />
                {t("ServiceP29")} <span>€ 180</span>
                <br />
                {t("ServiceP30")} <span>€ 180</span>
              </p>
              <p><span>{t("ServiceP31")}</span> {t("ServiceP32")}</p>
              {/* <p>
                {t("ServiceP17")} <span>{t("ServiceP18")}</span>
              </p> */}
              {/* <a
                href="https://wa.me/37129825460"
                className="btn btn-lg"
                target="_blank"
                rel="noreferrer"
              >
                {t("BookNow")}
              </a> */}
              <div className="d-flex justify-content-center flex-wrap">
                <a
                  href="https://wa.me/37129825460"
                  className="btn btn-lg me-0 me-md-3"
                  style={{ backgroundColor: "#25D366", color: "white" }}
                >
                  <FaWhatsapp className="me-1" /> {t("WhatsApp")}
                </a>
                <a
                  href="https://t.me/+37129825460"
                  className="btn btn-lg mt-2 mt-md-0"
                  style={{ backgroundColor: "#0088cc", color: "white" }}
                >
                  <FaTelegram className="me-1" /> {t("Telegram")}
                </a>
              </div>

              {/* <div className="card">
                <div className="card-body">
                  <div className="row d-flex flex-column flex-md-row">
                    <div className="col d-flex align-items-center">
                      <img
                        src={map}
                        className="rounded-5"
                        width="100%"
                        alt="..."
                      />
                    </div>
                    <div className="col">
                      <h4 className="mt-3 fw-bold">{t("Feature1")}</h4>
                      <p className="mt-1 text-break">
                        {t("Feature1Description")}
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
